import { render, staticRenderFns } from "./checkpay.vue?vue&type=template&id=c4262a4e&scoped=true&"
import script from "./checkpay.vue?vue&type=script&lang=js&"
export * from "./checkpay.vue?vue&type=script&lang=js&"
import style0 from "./checkpay.vue?vue&type=style&index=0&id=c4262a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4262a4e",
  null
  
)

export default component.exports